<template>
    <div class="wrap_app">

        <div class="account w_box">
            <div class="account_t">
                <h1>账户余额
                    <span>(不支持提现)</span>
                </h1>
                <h1 class="detail" @click="goPage('gold_detail',{
                    url:`/up/app/gold_detail`,
                })">
                    <span>金币明细</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 10 20" fill="none">
                        <path d="M2.35995 6L6.46853 9.74035C6.57602 9.83821 6.57767 10.0068 6.47211 10.1068L2.35995 14" stroke="#939393" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </h1>
            </div>
            <div class="account_box">
                <div class="account_box_i"></div>
                <div class="account_box_c">
                    <h1>
                        <b>{{ gold }}</b>金币
                    </h1>
                    <h2>含充值金币{{charge_gold}}，平台金币{{platform_gold}}</h2>
                </div>
                <div class="account_box_b" @click="goPage('earn_gold')">
                    <span>赚金币</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="17" viewBox="0 0 8 17" fill="none">
                    <path d="M1.88797 4.5777L5.95267 8.27811C6.03867 8.3564 6.03999 8.49128 5.95554 8.57124L1.88797 12.4223" stroke="#FE8820" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
        </div>


        <div class="charge w_box">
            <h1>充值</h1>
            <div class="charge_list">
                <div class="charge_item" v-for="(item,i) in charge_list"
                    :class="[i == charge_check ? 'charge_item_check' : '']"
                    @click="check(i,item)"
                    >
                    {{ item.amount }}{{ item.amount == '其他' ? '金额' : '金币' }}
                    <i v-if="item.state && item.give_amount">送{{ item.give_amount }}</i>
                    <svg v-if="i == charge_check" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                    <path d="M23 0.787323V23H0.787354L23 0.787323Z" fill="#FF443D"/>
                    <path d="M11.2061 16.6702L13.6402 19.1043C14.0307 19.4948 14.6639 19.4948 15.0544 19.1043L20.3366 13.8221" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                    </svg>
                </div>
            </div>

            <div class="charge_btn" @click="call_gold_charge">立即充值</div>
        </div>

        <a class="tip" href="www.baidu.com?l_id=108388#AiGuPiao_DirectMessages">
            充值问题，请联系在线客服 <span>爱股票小秘书</span>
            <p>温馨提示：账户金币仅限站内消费，不能兑换现金</p>
        </a>

        <div class="account w_box zan" v-if="show_reward_withdrawal">
            <div class="account_t">
                <h1>收到赞赏
                </h1>
                <h1 class="detail" @click="goPage('appreciation_detail')">
                    <span>赞赏明细</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 10 20" fill="none">
                        <path d="M2.35995 6L6.46853 9.74035C6.57602 9.83821 6.57767 10.0068 6.47211 10.1068L2.35995 14" stroke="#939393" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </h1>
            </div>
            <div class="account_box">
                <div class="zan_box_i">
                    <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
                        <g clip-path="url(#clip0_9368_38136)">
                            <g opacity="0.534401" filter="url(#filter0_f_9368_38136)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.65257 29.7879L2 31.7823L17.1158 39L48.5 31.4366L39.4254 27.1381L3.65257 29.7879Z" fill="#F78667"/>
                            </g>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.05859 26.6075L17.512 34.0146L47.385 26.9518L33.4749 21.5008L3.05859 26.6075Z" fill="#EB4D10"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.06653 26.5701V30.4162L17.614 38.0831V34.0553L3.06653 26.5701Z" fill="#FF7980"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5448 37.9513L47.385 30.678V26.9518L17.5448 34.0373V37.9513Z" fill="#FFADCE"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.05859 22.3571L17.512 29.7642L47.385 22.8426L33.4749 17.2504L3.05859 22.3571Z" fill="#EB4D10"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.06653 22.3197V26.1658L17.614 33.8327V29.8049L3.06653 22.3197Z" fill="#FF7980"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5448 33.7009L47.385 26.4276V22.8426L17.5448 29.7869V33.7009Z" fill="#FFADCE"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.05859 18.1067L17.512 25.5138L47.385 18.9619L33.4749 13L3.05859 18.1067Z" fill="url(#paint0_linear_9368_38136)"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.06653 18.0693V21.9154L17.614 29.5823V25.5545L3.06653 18.0693Z" fill="#FF7980"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5448 29.4505L47.385 22.4848V18.8927L17.5448 25.5365V29.4505Z" fill="#FFADCE"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.9661 15.2955L33.3627 22.2677L36.0245 21.7111L23.7055 14.9515L20.9661 15.2955Z" fill="#FFF2E3"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M33.3627 22.3482V34.2652L36.0244 33.6609V21.7111L33.3627 22.3482Z" fill="#FFF2E3"/>
                        </g>
                        <defs>
                            <filter id="filter0_f_9368_38136" x="-2.63854" y="22.4996" width="55.7771" height="21.139" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                            <feGaussianBlur stdDeviation="2.31927" result="effect1_foregroundBlur_9368_38136"/>
                            </filter>
                            <linearGradient id="paint0_linear_9368_38136" x1="16.5408" y1="10.1956" x2="14.4453" y2="22.5401" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#FFC1C0"/>
                            <stop offset="0.404775" stop-color="#FFD8D8"/>
                            <stop offset="1" stop-color="#FFB9BA"/>
                            </linearGradient>
                            <clipPath id="clip0_9368_38136">
                            <rect width="51" height="51" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="account_box_c">
                    <h1>
                        <b>¥ {{ available_received_amount }}</b>
                    </h1>
                </div>
                <div class="account_box_b account_box_b2" @click="goPage('appreciation_withdrawal')">
                    <span>提现</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="17" viewBox="0 0 8 17" fill="none">
                    <path d="M1.88797 4.5777L5.95267 8.27811C6.03867 8.3564 6.03999 8.49128 5.95554 8.57124L1.88797 12.4223" stroke="#FE8820" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
        </div>
        
        <div class="account w_box fp" @click="goPage('invoice')">
            <div class="account_t">
                <h1>发票
                    <span>(开票历史，修改开票信息)</span>
                </h1>
                <h1 class="fp_detail">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none">
                        <path d="M3.69998 6.87143L10.0511 12.6533C10.1855 12.7757 10.1875 12.9864 10.0556 13.1113L3.69998 19.1286" stroke="#939393" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </h1>
            </div>
        </div>

        <div class="account w_box cou">
            <div class="account_t">
                <h1>优惠券
                </h1>
                <h1 class="detail" @click="goPage('coupon')">
                    <span>查看更多</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="26" viewBox="0 0 14 26" fill="none">
                        <path d="M3.69998 6.87143L10.0511 12.6533C10.1855 12.7757 10.1875 12.9864 10.0556 13.1113L3.69998 19.1286" stroke="#939393" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </h1>
            </div>
            <div class="cou_box" v-if="list.length">
                <div class="cou_item" v-for="item in list" :key="item.id"
                    @click="goPage('coupon_detail',{
                        jump_kind:item.jump_kind,
                        jump_id:item.jump_id,
                        kind_label:item.kind_label,
                    })"
                    >
                    <div class="cou_item_l">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="90" viewBox="0 0 100 90" fill="none">
                            <path d="M96.3393 3.21429C98.1145 3.21429 99.5536 1.7752 99.5536 0H0V90H99.5536C99.5536 88.2248 98.1145 86.7857 96.3393 86.7857C98.1145 86.7857 99.5536 85.3466 99.5536 83.5714C99.5536 81.7962 98.1145 80.3571 96.3393 80.3571C98.1145 80.3571 99.5536 78.9181 99.5536 77.1429C99.5536 75.3677 98.1145 73.9286 96.3393 73.9286C98.1145 73.9286 99.5536 72.4895 99.5536 70.7143C99.5536 68.9391 98.1145 67.5 96.3393 67.5C98.1145 67.5 99.5536 66.0609 99.5536 64.2857C99.5536 62.5105 98.1145 61.0714 96.3393 61.0714C98.1145 61.0714 99.5536 59.6323 99.5536 57.8571C99.5536 56.0819 98.1145 54.6429 96.3393 54.6429C98.1145 54.6429 99.5536 53.2038 99.5536 51.4286C99.5536 49.6534 98.1145 48.2143 96.3393 48.2143C98.1145 48.2143 99.5536 46.7752 99.5536 45C99.5536 43.2248 98.1145 41.7857 96.3393 41.7857C98.1145 41.7857 99.5536 40.3466 99.5536 38.5714C99.5536 36.7962 98.1145 35.3571 96.3393 35.3571C98.1145 35.3571 99.5536 33.9181 99.5536 32.1429C99.5536 30.3677 98.1145 28.9286 96.3393 28.9286C98.1145 28.9286 99.5536 27.4895 99.5536 25.7143C99.5536 23.9391 98.1145 22.5 96.3393 22.5C98.1145 22.5 99.5536 21.0609 99.5536 19.2857C99.5536 17.5105 98.1145 16.0714 96.3393 16.0714C98.1145 16.0714 99.5536 14.6323 99.5536 12.8571C99.5536 11.0819 98.1145 9.64286 96.3393 9.64286C98.1145 9.64286 99.5536 8.20377 99.5536 6.42857C99.5536 4.65337 98.1145 3.21429 96.3393 3.21429Z" fill="url(#paint0_linear_8458_387)"/>
                            <defs>
                                <linearGradient id="paint0_linear_8458_387" x1="0" y1="0" x2="100" y2="90" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#FA4A14"/>
                                <stop offset="1" stop-color="#FC823F"/>
                                </linearGradient>
                            </defs>
                        </svg>
                        <h1>{{ item.kind_value }}折</h1>
                        <h2>折扣券</h2>
                    </div>
                    <div class="cou_item_r">
                        <h1>{{ item.kind_label }}</h1>
                        <p>{{ item.kind_intro }}</p>
                        <p class="expired_intro">{{ item.expired_intro }}</p>
                    </div>
                </div>
                <div class="loading nomore" v-if="isLoading">加载中...</div>
                <div class="nomore" v-if="!isLoading && !hasMore">{{ num_tips }}</div>
            </div>
            <div class="cou_box cou_box_no" v-if="list.length == 0 && !isLoading">
                <svg xmlns="http://www.w3.org/2000/svg" width="105" height="70" viewBox="0 0 105 70" fill="none">
                <path d="M52.5577 38.7766V61.8903L76.4969 51.9844L76.2906 27.2197L52.5577 38.7766Z" fill="#AFAFAF" fill-opacity="0.25"/>
                <path d="M76.2292 27.251L52.5969 13.9534V38.6697L76.2292 27.251Z" fill="#F6F6F6"/>
                <path d="M52.6375 38.5946V13.9763L30.9031 27.1998L52.6375 38.5946Z" fill="#E6E6E6"/>
                <path d="M52.5578 38.7766L60.3999 46.8251L76.4969 38.7766L84.3391 34.8555L76.2906 27.2197L52.5578 38.7766Z" fill="white"/>
                <path d="M52.5578 61.8903V38.7766M52.5578 61.8903L76.4969 51.9844V38.7766M52.5578 61.8903L30.6823 50.7462V38.7708M52.5578 38.7766L30.6823 27.2197M52.5578 38.7766L45.5411 46.8251L30.6823 38.7708M52.5578 38.7766L60.3999 46.8251L76.4969 38.7766M52.5578 38.7766L76.2906 27.2197M30.6823 27.2197L23.4592 34.8555L30.6823 38.7708M30.6823 27.2197L23.4592 20.6158L45.5411 7.61432L52.5578 14.0119M30.6823 27.2197L52.5578 14.0119M76.2906 27.2197L84.3391 34.8555L76.4969 38.7766M76.2906 27.2197L84.3391 20.6158L62.67 7.61432L52.5578 14.0119M76.2906 27.2197L52.5578 14.0119" stroke="#DADADA"/>
                <path d="M20.9655 56.7832C21.1456 56.6767 21.375 56.87 21.2702 57.0509C20.743 57.9605 19.6514 59.4266 18.0026 59.6432C16.3852 59.8557 15.1004 58.7517 14.4275 57.9984C14.2873 57.8414 14.4855 57.5932 14.6866 57.6554C15.345 57.8587 16.4012 58.0544 17.7702 57.8746C19.2146 57.6848 20.3145 57.1681 20.9655 56.7832Z" fill="#D9D9D9"/>
                <path d="M96.8268 40.6776C97.0027 40.5644 97.2319 40.7467 97.1288 40.9287C96.6787 41.7227 95.7833 42.9198 94.3509 43.249C92.944 43.5723 91.7416 42.8922 91.0583 42.3607C90.8931 42.2321 91.0429 41.9651 91.2502 41.9951C91.8699 42.0846 92.8261 42.1209 94.0282 41.8447C95.2927 41.5541 96.2455 41.0518 96.8268 40.6776Z" fill="#D9D9D9"/>
                </svg>
                <p>暂无可用优惠券，<span @click="goPage('earn_gold')">立即赚取金币</span></p>
            </div>
        </div>

    </div>
</template>

<script>
import goldApi from '@/api/gold/index.js'
import "@/utils/flexible";
import { scrollLoad } from "@/utils/index";
import {appversion,user_id,CURRENT_ENV_PRE,source} from "@/utils/urlQuery";
export default {
    data() {
        return {
            list:[],
            hasMore: true,
            isLoading: false,
            compare_to: 0,

            gold: 0,
            charge_gold: 0,
            platform_gold: 0,
            show_reward_withdrawal: 0,
            available_received_amount:0,

            charge_check:0,
            charge_list:[],

            num_tips:'没有更多优惠券了~'

        };
    },
    created() {
        this.getdata();
        this.getcharge();
        this.get_user_reward_amount();
        this.getlist();
    },
    mounted() {
        this.listenScrollFn();

        window.getdata = ()=>{
            this.getdata();
        }

        function handleSpecialCharacters(jsonStr) {
            let obj = {};
            if (jsonStr && Object.prototype.toString.call(jsonStr) == "[object String]" && jsonStr != 'null') {
                jsonStr = jsonStr.replace(/\n/g, "\<br/>");
                obj = JSON.parse(jsonStr)
            }
            return obj;
        }

        window.srNativeCallH5Method = (data) => {
            let params = null;
            if(source == 'ios') {
                params = JSON.parse(data);
            } else {
                params = handleSpecialCharacters(data);
            }
            if(params.method_name == 'gold_refresh') {
                //支付成功，刷新金币
                this.getdata();
            }
            if(params.method_name == 'cancel_gold_input'){
                this.check(0,{});
            } 
        };
    },
    methods:{
        // 跳转页面
        goPage(kind,data) {
          let params = {
            kind: kind,
          }
          if(data){
            params = {
                ...data,
                kind: kind,
            };
          }
          this.$srH5CallNativeMethodApp('call_Native',params)
        },
        call_gold_input(){
            this.$srH5CallNativeMethodApp('call_gold_input',{})
        },
        call_gold_charge(){
            this.$srH5CallNativeMethodApp('call_gold_charge',{
                gold: this.charge_list[this.charge_check].amount,
            })
        },
        check(i,item){
            this.charge_check = i;
            if(item.amount == '其他'){
                this.call_gold_input();
            }
        },
        async columnListMore() {
            if (this.isLoading || this.compare_to === 0 || !this.hasMore) {
                return;
            }
            await this.getlist();
        },
        listenScrollFn() {
            window.document.addEventListener(
                "scroll",
                scrollLoad(this.columnListMore),
                false
            );
        },
        async getlist() {
            this.isLoading = true;
            //appversion,user_id
            let params = {
                appversion:appversion,
                u_id:user_id,
                before:this.compare_to,
            }
            let res = await goldApi.Coupon(params);
            console.log('res',res)
            this.isLoading = false;
            if(res.rslt == "succ") {
                if (res.data.length === 0) {
                    this.hasMore = false;
                }
                else{
                    this.list = this.list.concat(res.data);
                    this.compare_to = this.list[this.list.length-1].rec_time;
                }
            }
            else {
                this.hasMore = false;
            }
        },
        getdatafn(res){
            if(res.rslt == "succ") {
                this.gold = res.gold;
                this.charge_gold = res.charge_gold;
                this.platform_gold = res.platform_gold;
                this.show_reward_withdrawal = res.show_reward_withdrawal;
            }
        },
        get_user_reward_amount(){
            let params = {
                appversion:appversion,
                u_id:user_id,
            }
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: "get",
                url: `https://app${CURRENT_ENV_PRE}.aigupiao.com/goapi/withdrawal/get_user_reward_amount?source=pc`,
                data:params,
                cache: false,
                async: true,
                error: function () {
                    return false;
                },
                success: function (res) {
                    if(res.status == "success"){
                        _this.available_received_amount = res.data.available_received_amount;
                    }
                },
            })
        },
        getcharge(){
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: "get",
                url: `https://app${CURRENT_ENV_PRE}.aigupiao.com/goapi/gold/get_gold_recharge_config`,
                cache: false,
                async: true,
                error: function () {
                    return false;
                },
                success: function (res) {
                    if(res.status == "success"){
                        _this.charge_list = res.data;
                        _this.charge_list.push(
                            {
                                "amount": '其他',
                                "give_amount": 0,
                                "state": 0,
                            }
                        )
                    }
                    else{
                        _this.charge_list = [
                            {
                                "amount": 100,
                                "give_amount": 10,
                                "state": 0
                            },
                            {
                                "amount": 500,
                                "give_amount": 20,
                                "state": 0
                            },
                            {
                                "amount": 1000,
                                "give_amount": 50,
                                "state": 0
                            },
                            {
                                "amount": 2000,
                                "give_amount": 150,
                                "state": 0
                            },
                            {
                                "amount": 5000,
                                "give_amount": 500,
                                "state": 0
                            },
                            {
                                "amount": '其他',
                                "give_amount": 0,
                                "state": 0,
                            }
                        ]
                
                    }
                },
            })
        },
        getdata() {
            let params = {
                appversion:appversion,
                u_id:user_id,
            }
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: "get",
                url: `https://app${CURRENT_ENV_PRE}.aigupiao.com/api/gold.php?act=surplus`,
                data:params,
                cache: false,
                async: true,
                error: function () {
                    return false;
                },
                success: function (res) {
                    _this.getdatafn(res)
                },
            })
            

        },
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";
    .wrap_app{
        min-height: 100vh;
        background: #F5F6F7;
        color: #333;
        font-size: rem2(15px);
    }


    .w_box{
        padding: rem2(12px);
        background: #FFF;
        margin-bottom: rem2(10px);
    }

    .account{
        

        .account_box{
            border-radius: 6px;
            border: 1px solid rgba(254, 136, 32, 0.15);
            background: rgba(254, 136, 32, 0.05);
            padding: rem2(15px) rem2(12px) rem2(17px) rem2(10px);
            display: flex;
            align-items: center;
            position: relative;
            //justify-content: space-between;
            
            .account_box_i{
                width: rem2(51px);
                height: rem2(51px);
                background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/gold_svg.svg);
                background-position: center;
                background-size: contain;
            }
            .account_box_c{
                margin-left: rem2(10px);
                color: #FD8820;
                h1{
                    font-size: rem2(14px);
                    margin-bottom: rem2(6px);
                }
                b{
                    font-size: rem2(26px);
                }
                h2{
                    font-size: rem2(12px);
                }
            }
            .account_box_b{
                position: absolute;
                right: rem2(12px);
                display: inline-flex;
                align-items: center;
                justify-content: space-between;
                border-radius: rem2(20px);
                background: rgba(248, 203, 134, 0.15);
                padding: rem2(4px) rem2(6px) rem2(4px) rem2(10px);

                svg{
                    width: rem2(10px);
                    height: rem2(20px);
                }
                span{
                    font-size: rem2(13px);
                    color: #FE8820;
                }

                &.account_box_b2{
                    padding-left: 20px;
                    padding-right: 16px;
                }
            }
        }

        .account_t{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: rem2(10px);
            span{
                color: #939393;
                font-size: rem2(14px);
            }
            .detail{
                display: flex;
                align-items: center;
                span{
                    font-size: rem2(13px);
                }
            }
            svg{
                width: rem2(10px);
                height: rem2(20px);
            }
        }
    }

    .charge{
        .charge_list{
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            margin: rem2(5px) 0;
            .charge_item{
                position: relative;
                flex-shrink: 0;
                width: rem2(109px);
                display: flex;
                align-items: center;
                justify-content: center;
                height: rem2(43px);
                border-radius: 4px;
                border: 1px solid #DCDCDC;
                margin: rem2(9px) 0;
                svg{
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: rem2(22px);
                    height: rem2(22px);
                }
                i{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/gold_svg2.svg);
                    background-position: center;
                    background-size: cover;
                    position: absolute;
                    left: 0;
                    top: rem2(-10px);
                    width: rem2(55px);
                    height: rem2(20px);
                    font-style: normal;  
                    font-weight: 500;
                    font-size: rem2(13px);
                    color: #fff;  
                }
            }
            .charge_item_check{
                border-color: #FF443D;
            }
        }
        .charge_btn{
            display: flex;
            width: 100%;
            height: rem2(38px);
            justify-content: center;
            align-items: center;
            border-radius: rem2(4px);
            background: #EB5752;
            color: #FFF;
        }
    }

    .tip{
        display: block;
        color: #636363;
        font-size: rem2(13px);
        padding: rem2(12px);
        padding-top: 0;
        line-height: 160%;
        span{
            color: #1D88D0;
        }
        p{
            color: #333;
            font-weight: bold;
        }
    }

    .zan{
        .account_box{
            padding: rem2(13px) rem2(12px) rem2(13px) rem2(10px);
            .zan_box_i{
                svg{
                    width: rem2(51px);
                    height: rem2(51px);
                }
            }
        }
    }

    .fp{
        .account_t{
            margin: 0;
        }
        .fp_detail{
            svg{
                width: rem2(12.5px);
                height: rem2(25px);
            }

        }
    }

    .cou{
        .account_t{
            margin: 0;
        }
        .cou_box{
            .cou_item{
                width: rem2(351px);
                height: rem2(90px);
                display: flex;
                align-items: center;
                margin: rem2(10px) 0;
                border-radius: rem2(8px);
                border: rem2(1px) solid #ebebeb;

                .cou_item_l{
                    width: rem2(99.554px);
                    height: rem2(90px);
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    margin-right: rem2(13px);
                    h2{
                        color: #FFF;
                        text-align: center;
                        font-size: rem2(14px);
                        line-height: 100%; 
                        position: relative;
                    }
                    h1{
                        color: #FFF;
                        text-align: center;
                        font-size: rem2(22px);
                        font-weight: bold;
                        line-height: 100%; 
                        position: relative;
                        margin-bottom: rem2(8px);
                    }
                    svg{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        border-radius: rem2(8px);
                    }
                }
                .cou_item_r{
                    color: #636363;
                    font-size: rem2(13px);
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: rem2(12px) 0;
                    height: 100%;
                    box-sizing: border-box;
                    

                    h1{
                        color: #333;
                        font-size: rem2(15px);
                        font-weight: bold;
                    }
                    h1,p{
                        //margin-bottom: rem2(5px);
                    }

                    .expired_intro{
                        font-size: 12px;
                    }
                }
            }
        }
        .cou_box_no{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: rem2(25px);
            svg{
                width: rem2(105px);
                height: rem2(70px);
            }
            p{
                text-align: center;
                color: #939393;
                font-size: rem2(13px);
                margin: rem2(10px) 0;
            }
            span{
                color: #1D88D0;
            }
        }
    }

    .nomore{
        padding: rem2(10px) rem2(12px);
        font-size: rem2(15px);
        color: #939393;
        text-align: center;
    }

</style>